<script setup lang="ts">
import { SEO_DEFAULTS } from '~/utils/constants'
useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  link: [{ rel: 'icon', href: '/favicon.png' }],
  htmlAttrs: {
    lang: 'en',
  },
})

const title = SEO_DEFAULTS.FULL_TITLE
const description = SEO_DEFAULTS.DESCRIPTION

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: SEO_DEFAULTS.OG_IMAGE,
  twitterImage: SEO_DEFAULTS.OG_IMAGE,
  twitterCard: 'summary_large_image',
})

onErrorCaptured((err) => {
  console.error('[GlobalError]', err)
})
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
